import createAPI from '../axios'

// 系统管理相关 API
const system = {
    // 用户基本权限
    basic: {
        userMenu: config => createAPI('/user/menu', 'get', config),
        userInfo: config => createAPI('/user/info', 'get', config),
        userLogin: config => createAPI('/user/login', 'post', config),
        userLogout: config => createAPI('/user/logout', 'post', config),
        autoLogin4Wx: config => createAPI('/user/autoLogin4Wx', 'post', config),
        changePwd: config => createAPI('/user/change-pwd', 'post', config),
        queryUserModule: config => createAPI('/user/queryUserModule', 'post', config),
    },
    // 配置项管理
    config: {
        list: config => createAPI('/admin/configure/list', 'post', config),
        save: config => createAPI('/admin/configure/save', 'post', config),
        delete: config => createAPI('/admin/configure/del', 'delete', config),
        getParamValue: config => createAPI('/admin/configure/param-value', 'post', config)
    },
    // 菜单管理
    menu: {
        map: config => createAPI('/menu/father-menus', 'get', config),
        list: config => createAPI('/menu/list', 'post', config),
        save: config => createAPI('/menu/save', 'post', config),
        delete: config => createAPI('/menu/del', 'delete', config),
        modelList: config => createAPI('/resource/sonlist','post',config)
    },
    // 角色管理
    role: {
        list: config => createAPI('/role/list', 'get', config),
        all: config => createAPI('/role/all', 'post', config),
        save: config => createAPI('/role/save', 'post', config),
        delete: config => createAPI('/role/del', 'delete', config),
        getMenu: config => createAPI('/role/get-menu', 'post', config),
        getUser: config => createAPI('/role/get-user', 'post', config),
        saveUser: config => createAPI('/role/save-user', 'post', config),
        savePrivilege: config => createAPI('/role/save-privilege', 'post', config),
        getResource: config => createAPI('/role/get-resource', 'post', config),
        saveResource: config => createAPI('/role/save-resource', 'post', config),
        listBytoken: config => createAPI('/role/listBytoken', 'post', config),
    },
    //资源权限行为
    action: {
        getClasses: config => createAPI('/action/get-classes', 'get', config),
        all: config => createAPI('/action/all', 'get', config),
        getResources: config => createAPI('/action/get-resources', 'post', config),
        batchSave: config => createAPI('/action/batch-save', 'post', config),
        delete: config => createAPI('/action/delete', 'delete', config),
    },
    // 用户管理
    user: {
        list: config => createAPI('/user/list', 'post', config),
        save: config => createAPI('/user/save', 'post', config),
        delete: config => createAPI('/user/del', 'delete', config),
        resetPwd: config => createAPI('/user/reset-pwd', 'post', config),
    },
    // 部门管理
    department: {
        list: config => createAPI('/department/list', 'post', config),
        save: config => createAPI('/department/save', 'post', config),
        delete: config => createAPI('/department/del', 'delete', config),
        listmenu: config => createAPI('/department/listmenu', 'post', config),
    },
	apply:{
		upload:config => createAPI('/file/file/upload', 'post', config),
		download:config => createAPI('/file/file/download', 'post', config),
        list: config => createAPI('/file/list', 'post', config),
	},
    test:{
        test:config => createAPI('/test/test', 'post', config),
        findUser:config => createAPI('/test/findUser', 'post', config),
        checkLogin:config => createAPI('/test/checkLogin', 'post', config),
        logout:config => createAPI('/test/logout', 'post', config),
    },
    file:{
         preview:config => createAPI('/file/file/preview', 'post', config),
    },
    // 考勤,查,增,改,删
    wcheck: {
        cx: config => createAPI('/wcheck/cx', 'post', config),
        save: config => createAPI('/wcheck/save', 'post', config),
        sc: config => createAPI('/wcheck/sc', 'delete', config),
        import: config => createAPI('/wcheck/import', 'post', config),
        export: config => createAPI('/wcheck/export', 'post', config),
    },
    //数据权限配置
    dataAuth: {
        initCombo: config => createAPI('/dataAuth/initCombo', 'post', config),
        list: config => createAPI('/dataAuth/list', 'post', config),
        save: config => createAPI('/dataAuth/save', 'post', config),
        del: config => createAPI('/dataAuth/del', 'post', config),
        queryUserDataAuth: config => createAPI('/dataAuth/queryUserDataAuth', 'post', config),
        queryUserDataAuthAdultEducation: config => createAPI('/dataAuth/queryUserDataAuthAdultEducation', 'post', config),
        queryUserDataAuthSkillsTraining: config => createAPI('/dataAuth/queryUserDataAuthSkillsTraining', 'post', config),
    },
    //选项管理
    optionManage: {
        queryTree: config => createAPI('/system/optionManage/queryTree', 'post', config),
        save: config => createAPI('/system/optionManage/save', 'post', config),
        del: config => createAPI('/system/optionManage/del', 'post', config),
    },
};

export default system;



// WEBPACK FOOTER //
// ./src/api/modules/system.js